module.exports = __webpack_public_path__ + "static/img/Jacob-Weitering.0e6feb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jacob-Weitering.jpg
// module id = V8fw
// module chunks = 0